import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL: /en/whitepapers/<slug> moved to /en/downloads/<slug>.
// Thrown from beforeLoad so SSR answers with a real HTTP redirect.
export const Route = createFileRoute("/en/whitepapers/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/en/downloads/$slug",
      params: { slug: params.slug },
      replace: true,
      statusCode: 301,
    });
  },
});
